import React from 'react';
import PaymentHistory from '../payment/PaymentHistory';
import './Transactions.css';

const Transactions = () => {
  return (
    <div className="transactions">
      <PaymentHistory />
    </div>
  );
};

export default Transactions;










